import { render, staticRenderFns } from "./LabelSuggestion.vue?vue&type=template&id=269f3c8f&scoped=true&"
import script from "./LabelSuggestion.vue?vue&type=script&lang=js&"
export * from "./LabelSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./LabelSuggestion.vue?vue&type=style&index=0&id=269f3c8f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269f3c8f",
  null
  
)

export default component.exports